import React from "react";
import Text from "../../components/typography/Text";
import Button from "../../components/buttons/Button";
import MediumArticle from "../../components/mediumArticles/MediumArticle";
import useApi from "../../hooks/useApi";
import { Link } from "react-router-dom";

const PastProjects = ({ title, description, button_label }) => {
  const { data: projects } = useApi("/past_project?per_page=3");
  return (
    <div className="oHomePastProjects">
      <div className="oHomePastProjects_infos">
        {title && <h1>{title}</h1>}
        {description && <Text big>{description}</Text>}
        <Link to="/showcase">
          <Button orange arrowRight outlined rounded>
            {button_label || "View all done projects"}
          </Button>
        </Link>
      </div>
      <div className="oHomePastProjects_list">
        {projects &&
          projects.map((project) => (
            <MediumArticle {...project} key={project.id} />
          ))}
      </div>
    </div>
  );
};

export default PastProjects;
